import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    admissionReportDataLoading: false,
    admissionReportDataSuccess: {},
    admissionReportDataError: "",
    facultyLoadBalanceReportDataLoading: false,
    facultyLoadBalanceReportDataSuccess: {},
    facultyLoadBalanceReportDataError: "",
    profileReportDataLoading: false,
    profileReportDataSuccess: {},
    profileReportDataError: "",
    batchReportDataLoading: false,
    batchReportDataSuccess: {},
    batchReportDataError: "",
}


export const admissionTypeSlice = createSlice({
    name: 'admission-report',
    initialState,
    reducers: {
        setAdmissionReportDataLoading: (state, action) => {
            state.admissionReportDataLoading = true;
            state.admissionReportDataSuccess = {};
            state.admissionReportDataError = "";

        },
        setAdmissionReportDataSuccess: (state, action) => {
            state.admissionReportDataLoading = false;
            state.admissionReportDataSuccess = action.payload;
            state.admissionReportDataError = "";
        },
        setAdmissionReportDataError: (state, action) => {
            state.admissionReportDataLoading = false;
            state.admissionReportDataSuccess = {}
            state.admissionReportDataError = action.payload.message
        },
        setFacultyLoadBalanceReportDataLoading: (state, action) => {
            state.facultyLoadBalanceReportDataLoading = true;
            state.facultyLoadBalanceReportDataSuccess = {};
            state.facultyLoadBalanceReportDataError = "";

        },
        setFacultyLoadBalanceReportDataSuccess: (state, action) => {
            state.facultyLoadBalanceReportDataLoading = false;
            state.facultyLoadBalanceReportDataSuccess = action.payload;
            state.facultyLoadBalanceReportDataError = "";
        },
        setFacultyLoadBalanceReportDataError: (state, action) => {
            state.facultyLoadBalanceReportDataLoading = false;
            state.facultyLoadBalanceReportDataSuccess = {}
            state.facultyLoadBalanceReportDataError = action.payload.message
        },
        setProfileReportDataLoading: (state, action) => {
            state.profileReportDataLoading = true;
            state.profileReportDataSuccess = {};
            state.profileReportDataError = "";
        },
        setProfileReportDataSuccess: (state, action) => {
            state.profileReportDataLoading = false;
            state.profileReportDataSuccess = action.payload;
            state.profileReportDataError = "";
        },
        setProfileReportDataError: (state, action) => {
            state.profileReportDataLoading = false;
            state.profileReportDataSuccess = {}
            state.profileReportDataError = action.payload.message
        },
        setBatchReportDataLoading: (state, action) => {
            state.batchReportDataLoading = true;
            state.batchReportDataSuccess = {};
            state.batchReportDataError = "";
        },
        setBatchReportDataSuccess: (state, action) => {
            state.batchReportDataLoading = false;
            state.batchReportDataSuccess = action.payload;
            state.batchReportDataError = "";
        },
        setBatchReportDataError: (state, action) => {
            state.batchReportDataLoading = false;
            state.batchReportDataSuccess = {}
            state.batchReportDataError = action.payload.message
        },

    },
})

// Action creators are generated for each case reducer function
export const { setAdmissionReportDataLoading, setAdmissionReportDataSuccess, setAdmissionReportDataError, setProfileReportDataLoading, setProfileReportDataSuccess, setProfileReportDataError, setBatchReportDataLoading, setBatchReportDataSuccess, setBatchReportDataError,
    setFacultyLoadBalanceReportDataError, setFacultyLoadBalanceReportDataLoading, setFacultyLoadBalanceReportDataSuccess
} = admissionTypeSlice.actions

export default admissionTypeSlice.reducer;